import { UserStore } from './modules/dashboard/user.store';

export class DashboardRootStore {
    public userStore: UserStore;

    constructor() {
        this.userStore = new UserStore(this);
    }
}
